export const selectFiltersOptions = state => state.filters.filtersOptions;

export const selectIsFetchingFiltersOptions = state =>
  state.filters.isFetchingOptions;

export const selectColorFiltersOptions = state =>
  state.filters.initialFilterOptions?.colorFilters.options?.map(option => ({
    ...option,
    count:
      state.filters.filtersOptions?.colorFilters.options?.find(
        ({ id }) => id === option.id,
      )?.count || 0,
  })) || [];

export const selectSizeFiltersOptions = state =>
  state.filters.initialFilterOptions?.sizeFilters.sections?.map(
    initialSection => ({
      ...initialSection,
      options: initialSection.options.map(initialOption => ({
        ...initialOption,
        count:
          state.filters.filtersOptions?.sizeFilters.sections?.map(
            ({ options }) =>
              options.find(option => option.id === initialOption.id)?.count,
          )[0] || 0,
      })),
    }),
  ) || [];
